/**
 * The bigtoto.shop mark: a crimped bottle cap, drawn rather than emoji.
 *
 * Inline SVG, not an <img>, for two reasons: it inherits `currentColor` so the
 * mark works on paper and on chalkboard without a second asset, and it costs no
 * request — which matters on a deployment with no CDN in front of it.
 */
export function CapMark({ className = 'h-6 w-6' }: { className?: string }) {
  const teeth = Array.from({ length: 24 }, (_, index) => {
    const angle = (Math.PI * index) / 12 - Math.PI / 2;
    const radius = index % 2 === 0 ? 12.2 : 10.1;
    return `${(16 + radius * Math.cos(angle)).toFixed(2)},${(16 + radius * Math.sin(angle)).toFixed(2)}`;
  }).join(' ');

  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden focusable="false">
      <polygon points={teeth} fill="currentColor" />
      <circle cx="16" cy="16" r="6.4" fill="var(--color-paper-50)" />
      <circle cx="16" cy="16" r="2.5" fill="currentColor" />
    </svg>
  );
}

/**
 * The wordmark.
 *
 * The domain is the brand, so it is set as one unit — "bigtoto" carries the
 * weight and ".shop" trails it in the muted tone, the way a shopfront sign
 * treats the street number.
 */
export function Wordmark({ tone = 'ink' }: { tone?: 'ink' | 'chalk' }) {
  const strong = tone === 'chalk' ? 'text-chalk' : 'text-ink-950';
  const weak = tone === 'chalk' ? 'text-chalk/45' : 'text-ink-500';

  return (
    <span className="sign flex items-baseline text-[16px] leading-none tracking-[0.16em]">
      <span className={strong}>bigtoto</span>
      <span className={`${weak} tracking-[0.1em]`}>.shop</span>
    </span>
  );
}
